import {BrowserRouter, Route, Routes} from 'react-router-dom';
import React from "react";
import PrivateRoute from "../../Common/component/PrivateRoute/PrivateRoute";
import ErrPage from "../../Common/pages/ErrPage";
import LoginPage from "../component/Conditional-Rendering/login/LoginPage";
import IndexPage from "../component/Conditional-Rendering/index/IndexPage";
import DocViewPage from "../component/Conditional-Rendering/docView/DocViewPage";
import AdminLoginPage from "../component/Conditional-Rendering/admin/login/AdminLoginPage";
import AdminIndex from "../component/admin/index/AdminIndex";
import PopupGate from "../common/PopupGate/PopupGate";
import BatchPrinter from "../../Common/component/BatchPrinter/BatchPrinter";

function DocuWizRouter() {

     return (
            <BrowserRouter>
                <Routes>
                    <Route element={<PrivateRoute isAdminMode={false} authentication={false}/>}>
                        <Route path="/print/:param" element={<BatchPrinter/>} />
                    </Route>
                    <Route element={<PrivateRoute isAdminMode={false} authentication={false}/>}>
                        <Route path="/login/:param" element={<LoginPage/>} />
                    </Route>
                    <Route element={<PrivateRoute isAdminMode={false} authentication={false}/>}>
                        <Route path="/login/popup/:param" element={<PopupGate/>} />
                    </Route>
                    <Route element={<PrivateRoute isAdminMode={false} authentication={true}/>}>
                        <Route path="/:openParam" element={<IndexPage/>} />
                    </Route>
                    <Route element={<PrivateRoute isAdminMode={false} authentication={true}/>}>
                        <Route path="/docView/:openParam/:currentDocId" element={<DocViewPage/>} />
                    </Route>
                    <Route element={<PrivateRoute isAdminMode={false} authentication={false}/>}>
                        <Route path="/admin" element={<AdminLoginPage/>} />
                    </Route>
                    <Route element={<PrivateRoute isAdminMode={true} authentication={true} children={<AdminLoginPage/>}/>}>
                        <Route path="/admin/:openParam" element={<AdminIndex/>} />
                    </Route>
                    <Route element={<PrivateRoute isAdminMode={false} authentication={false} />}>
                        <Route path="/error/:errCodeParam" element={<ErrPage/>} />
                    </Route>

                    {/* 상단에 위치하는 라우트들의 규칙을 모두 확인, 일치하는 라우트가 없는경우 처리 ddd*/}
                    <Route path="*" element={<ErrPage errCode={9999} />}></Route>
                </Routes>
            </BrowserRouter>
    );
}
export default DocuWizRouter;